import { useCommonStore } from '@/store/modules/common'
import { useResources } from '@/hooks/useResource'
import { findResourceByCode } from '@/utils/resource'
import { COMMON_RESOURCE_MARKS } from '@/constants/resource-marks'

// 封装 logo 获取逻辑
export function useLogo() {
  const commonStore = useCommonStore()

  // 使用 computed 确保响应式更新
  const logoImgSrc = computed(() => commonStore.getCommonData('logoUrl'))

  // logo 属全局初始化路径（App.vue 启动 / 微信分享），按需触发，不能立即请求
  const { load: loadCommonResource } = useResources([COMMON_RESOURCE_MARKS.COMMON], {
    immediate: false,
  })

  const getLogoImg = async () => {
    // 如果已有 logo，直接返回
    if (logoImgSrc.value) return logoImgSrc.value

    try {
      const [resources = []] = await loadCommonResource()
      const logoResource = findResourceByCode(resources, COMMON_RESOURCE_MARKS.LOGO)
      if (logoResource?.url) {
        commonStore.setCommonData('logoUrl', logoResource.url)
        return logoResource.url
      }

      return null
    } catch (error) {
      console.error('获取 Logo 出错:', error)
      return null
    }
  }
  return {
    logoImgSrc: logoImgSrc.value,
    logoImgSrcRef: logoImgSrc, // 提供响应式引用
    getLogoImg,
  }
}
